export default "__VITE_ASSET__BgDVKZCC__"